const STORAGE_KEY = 'nbh.push.declined';

/**
 * "I turned alerts off on this device" — a per-device preference, kept beside the D18
 * device id in localStorage for the same reason: it is a fact about this handset, not
 * about the account, and it needs no schema.
 *
 * It exists so the enrolment banner stops asking. `PushEnableBanner` offers "Turn on
 * alerts" whenever the device is not subscribed, which is exactly the state the settings
 * toggle leaves a device in when somebody chooses off — so without this the banner
 * would reappear the moment they chose. The banner is a prompt; the toggle is a control.
 * Only the prompt goes quiet: the toggle stays visible in every state regardless.
 *
 * Cleared when alerts are switched back on. Clearing site data clears it too, which is
 * the safe direction — the device looks new and is simply asked once more.
 */
export function hasDeclinedPush(): boolean {
  try {
    return localStorage.getItem(STORAGE_KEY) === '1';
  } catch {
    // Private browsing or blocked storage: nothing was declined that we can remember.
    return false;
  }
}

export function setPushDeclined(declined: boolean): void {
  try {
    if (declined) localStorage.setItem(STORAGE_KEY, '1');
    else localStorage.removeItem(STORAGE_KEY);
  } catch {
    // Storage refused: the banner may ask again after a reload. Not worth surfacing.
  }
}
